module.exports = __webpack_public_path__ + "static/img/img.32f84b75.jpg";